import styles from "./AxioLoader.module.css";

type LoaderSize = "sm" | "md" | "lg";

interface AxioLoaderProps {
  size?: LoaderSize;
  className?: string;
}

export function AxioLoader({ size = "md", className }: AxioLoaderProps) {
  const sizeClass = size === "md" ? "" : styles[size];
  const classes = [styles.wrapper, sizeClass, className].filter(Boolean).join(" ");

  return (
    <div className={classes} role="status" aria-label="Loading">
      <div className={styles.bar} />
    </div>
  );
}
